import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

import { isSupabaseAuthProvider } from "@/utils/auth-provider";
import { env } from "@/utils/env";

import type { AuthSession } from "./types";

import { authClient } from "./client";
import { auth } from "./config";
import { getSupabaseAuthSession } from "./supabase";

export const getSession = createIsomorphicFn()
  .client(async (): Promise<AuthSession | null> => {
    const { client } = await import("@/integrations/orpc/client");
    const flags = await client.flags.get();

    if (isSupabaseAuthProvider(flags.authProvider)) {
      const { getSupabaseAuthSessionServerFn } = await import("./supabase-functions");
      return (await getSupabaseAuthSessionServerFn()) as AuthSession | null;
    }

    const { data, error } = await authClient.getSession();
    if (error) return null;
    return data as AuthSession;
  })
  .server(async (): Promise<AuthSession | null> => {
    if (isSupabaseAuthProvider(env.MULTIRESUME_AUTH_PROVIDER)) {
      return (await getSupabaseAuthSession()) as AuthSession | null;
    }

    const result = await auth.api.getSession({ headers: getRequestHeaders() });
    return result as AuthSession | null;
  });
